import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type OrganisationTeam from "./OrganisationTeam";
import type User from "./User";

@Model()
class UsersOrganisationTeam extends ApplicationRecord {
  static jsonapiType = "users_organisation_teams";

  @BelongsTo() organisationTeam: OrganisationTeam;

  @Attr() organisationTeamId: number;

  @Attr() primary: boolean;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default UsersOrganisationTeam;
